<template>
	<div class="root">
		<!--<div class="pane-header">Caller Profile</div>-->
		<div class="user-info">
			<img src="../assets/profilepic.png">
			<dl class="data">
				<dt>Name</dt><dd>{{firstName}} {{lastName}}</dd>
				<dt>Phone</dt><dd>{{phoneNumber}}</dd>
				<dt>Email</dt><dd>{{email}}</dd>
				<dt>Language</dt><dd>{{language}}</dd>
			</dl>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProfilePane',
	props: {
		phoneNumber: String,
		data: Object
	},
	computed: {
		firstName() {
			return this.data.firstName;
		},
		lastName() {
			return this.data.lastName;
		},
		email() {
			return this.data.email;
		},
		language() {
			return this.data.language;
		},
		bloodType() {
			return this.data.bloodType;
		},
		hearingImpaired() {
			return this.data.hearingImpaired;
		},
		height() {
			return this.data.height;
		},
		weight() {
			return this.data.weight;
		},
		special() {
			return this.data.special;
		},
	}
};
</script>

<style scoped lang="scss">
@import '~styles/fibonacci';
@import '~styles/colors';

$term-width: 100px;

.root {
	background: white;
	overflow-y: auto;
}

.pane-header {
	text-align: center;
	//font-size: 1.5em;
	padding: 0.25em;
	background: $light-gray;
}

.user-info {
	@extend %rowParent;
	display: flex;
	//height: 100%;
	padding: 10px;
	box-sizing: border-box;
	border-bottom: 1px solid $light-gray;
	align-items: center;

	img {
		height: 100px;
		width: 100px;
		@extend .flexChild;
		flex: 0 0 100px;
		padding: 10px;
	}

	.data {
		display: flex;
		padding: 10px;
		margin: 0;
		flex-wrap: wrap;
		box-sizing: border-box;
		align-items: flex-start;
		align-content: flex-start;
		flex: 1;

		dt, dd {
			margin: 0 0 1px;
			padding: .25rem .5rem;
			word-wrap: break-word;
			box-sizing: border-box;
		}

		dt {
			justify-content: flex-end;
			flex: 0 0 24%;
		}
		dd {
			flex: 73% 0 0;
		}

		dd + dd {
			margin-left: 24%;
		}
	}
}
</style>
